import React from 'react';
import RouterList from './routes/routes';
import './App.css'
// import Toast from './components/Toast'; // uncomment if you use toast

const App = () => {
  return (
    <>
      {/* ============== Routes ============= */}
      <RouterList />

      {/* ======= Notification Toast ===========  */}
      {/* <Toast /> */}
    </>
  );
};

export default App;
